import { render, staticRenderFns } from "./PackageEdit.vue?vue&type=template&id=c7cc0c8e&scoped=true"
import script from "./PackageEdit.vue?vue&type=script&lang=js"
export * from "./PackageEdit.vue?vue&type=script&lang=js"
import style0 from "./PackageEdit.vue?vue&type=style&index=0&id=c7cc0c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cc0c8e",
  null
  
)

export default component.exports